import { IDmNhomLoaiThuChi } from "../../model/respone/category/IDmNhomLoaiThuChi";
import { apiClient } from "../apiClient";
export const NHOM_LOAI_THU_CHI_ENDPOINT = "nhom-loai-thu-chi";
export const nhomLoaiThuChiApi = {
  SelectAll: () => apiClient.get(`${NHOM_LOAI_THU_CHI_ENDPOINT}`),
  Insert: (payload: IDmNhomLoaiThuChi) =>
    apiClient.post(`${NHOM_LOAI_THU_CHI_ENDPOINT}`, payload),
  Update: (payload: IDmNhomLoaiThuChi) =>
    apiClient.put(`${NHOM_LOAI_THU_CHI_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${NHOM_LOAI_THU_CHI_ENDPOINT}/${id}`),
};
